export function date2german(date) {
  return date? date.toLocaleDateString(undefined, { day: "2-digit", year: "numeric", month:"2-digit"}) : "-";
}

export function datetime2german(date) {
  return date? date.toLocaleDateString(undefined, { day: "2-digit", year: "numeric", month:"2-digit", hour: "2-digit", minute:"2-digit"}) : "-";
}

export function json2germanNoTime(date) {
  // Input Format: 2021-07-14T16:41
  // Output Format: 14.07.2021 
  if (!date) return date
  let result = date.substr(8,2) + "." + date.substr(5,2) + "." + date.substr(0,4);
  return result;
}

export function json2german(date) {
  // Format: 2021-07-14T16:41
  if (!date) return date
  let result = date.substr(8,2) + "." + date.substr(5,2) + "." + date.substr(0,4);
  if (date.length>10) {
    result += " " + date.substr(11,5);
  }
  return result;
}

export function date2XMLRDB(date) {
  const timezoneOffsetmSec = date.getTimezoneOffset() * 1000 * 60;
  const d = new Date(date - timezoneOffsetmSec).toISOString();
  return d.substring(0, d.length - 1); // Z am Ende abschneiden, weil wir wollen keine Zeitzone
}

export function dateSortableString(date) {
  return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
}

/**
 * 
 * @param {Date} date 
 */
export function datetimeSortableString(date) {
  return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours()).slice(-2) + ("0" + date.getMinutes()).slice(-2);
}

const second = 1000;
const minute = second * 60;
const hour = minute * 60;
const day = hour * 24;
const week = day * 7;


export let intervals = {
  second,
  minute,
  hour,
  day,
  week
}